export const BNK_STMT_moveBackConvUIReducer = {
  BNK_STMT_moveBackConvUI: (state, action) => {
    // const { screenConstHistory, currentScreen, previousScreen } = state;
    state.screenConstHistory.pop();
    const lastScreenCombination = state.screenConstHistory.pop();
    state.screenConstHistory = [
      ...state.screenConstHistory,
      lastScreenCombination,
    ];
    const [previousScreen, currentScreen] = lastScreenCombination;
    state.previousScreen = previousScreen;
    state.currentScreen = currentScreen;
  },
};
